import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Bin from '@gef-ui/components/atoms/SvgIcon/Icons/Bin';
import BinActive from '@gef-ui/components/atoms/SvgIcon/Icons/BinActive';

// todo - mui prop is temporary workaround, older non MUI parts of app need old "Link" styling
const BinIcon = ({ id, onClick, mui = false }) => {
	const [open, setOpen] = useState(false);

	const handleOpen = useCallback(() => {
		setOpen(true);
	}, []);

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	const handleClick = useCallback(() => {
		onClick(id);
	}, [onClick, id]);

	return open ? (
		<BinActive
			onClick={handleClick}
			onMouseOver={handleOpen}
			onMouseOut={handleClose}
			style={{ fontSize: '14px' }}
			{...(!mui && { className: 'Link' })}
		/>
	) : (
		<Bin
			onClick={handleClick}
			onMouseOver={handleOpen}
			onMouseOut={handleClose}
			style={{ fontSize: '14px' }}
			{...(!mui && { className: 'Link' })}
		/>
	);
};

BinIcon.propTypes = {
	id: PropTypes.number,
	mui: PropTypes.bool,
	onClick: PropTypes.func,
};

export default BinIcon;
